export default {
	removeCommas(str) {
		return str.replace(/,/g, "");
	},
	addCommas(number) {
		if (number) {
			return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	},
	numberToWords(number) {
		const units = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
		const teens = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];
		const tens = ["", "", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
		const hundreds = ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];

		function threeDigitToText(n) {
			let h = Math.floor(n / 100);
			let t = Math.floor((n % 100) / 10);
			let u = n % 10;
			let parts = [];
			if (h > 0) {
				parts.push(hundreds[h]);
			}
			if (t === 1) {
				parts.push(teens[u]);
			} else {
				if (t > 1) {
					parts.push(tens[t]);
				}
				if (u > 0) {
					parts.push(units[u]);
				}
			}
			return parts.join(" و ");
		}

		if (number === 0) {
			return "صفر";
		}

		let parts = [];
		let billion = Math.floor(number / 1000000000);
		let million = Math.floor((number % 1000000000) / 1000000);
		let thousand = Math.floor((number % 1000000) / 1000);
		let rest = number % 1000;

		if (billion > 0) {
			parts.push(threeDigitToText(billion) + " میلیارد");
		}
		if (million > 0) {
			parts.push(threeDigitToText(million) + " میلیون");
		}
		if (thousand > 0) {
			parts.push(threeDigitToText(thousand) + " هزار");
		}
		if (rest > 0) {
			parts.push(threeDigitToText(rest));
		}

		return parts.join(" و ");
	},
}
